import ModalContentWithCloseButton from "../../../../common/ModalContentWithCloseButton";
import Button from "../../../../common/Button";
import Modal from "../../../../common/Modal";
import { BillOfMaterials } from "../../../../../reducers/uploadedBoard";
import {
  useBillOfMaterials,
  useUpdateBoardElementSelection,
} from "../../../../../utils/hooks/commonly-stored/uploaded-board/updates/billOfMaterials";

export default function MarkAllDNP({
  show,
  close,
}: {
  show: boolean;
  close: () => void;
}) {
  const billOfMaterials = useBillOfMaterials() as BillOfMaterials;
  const updateBoardElementSelection = useUpdateBoardElementSelection();

  const handleClick = () => {
    updateBoardElementSelection(
      billOfMaterials.elements
        .filter((element) => !element.do_not_populate)
        .map((element) => ({
          elementName: element.name,
          elementId: element.id,
          doNotPopulate: true,
          part_id: element.part_id,
          isConsignment: false,
          lockAllocation: false,
          elementPlacement: null,
        })),
      close,
    );
  };

  return (
    <Modal isOpen={show} onRequestClose={close}>
      <ModalContentWithCloseButton
        closeModal={close}
        title={"Mark all elements do not populate"}
      >
        While we specialize in super fast assemblies, we realize you may
        sometimes want a blank board.
        <Button
          styleProps={{ margin: "auto", marginTop: "1rem" }}
          label={"Mark DNP"}
          onClick={handleClick}
        />
      </ModalContentWithCloseButton>
    </Modal>
  );
}
